import axios from "axios";
import Cookies from "js-cookie";

export const addLead = ({ managerEmail, requestBody }) =>
  axios.post(`${process.env.REACT_APP_HOME_API_DOMAIN}/addLead`, requestBody, {
    headers: {
      Authorization: `Bearer ${Cookies.get(`jwt__${managerEmail}`)}`,
    },
  });

export const archiveProposal = ({ managerEmail, requestBody }) =>
  axios.patch(
    `${process.env.REACT_APP_API_GATEWAY}/user/proposals/archive`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${managerEmail}`)}`,
      },
    }
  );

export const updateBuilderWelcomeModalVisibilityAdvisor = ({ userEmail }) =>
  axios.put(
    `${process.env.REACT_APP_API_GATEWAY}/level/userManager/profileSettings/notificationWelcome`,
    { set: true },
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const updateFavoriteProductsWealthAdvisor = ({
  requestBody,
  userEmail,
}) =>
  axios.put(
    `${process.env.REACT_APP_API_GATEWAY}/level/userManager/profileSettings/favoriteProducts`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );

export const updateHoldingColumnOrderWealthAdvisor = ({
  requestBody,
  userEmail,
}) =>
  axios.put(
    `${process.env.REACT_APP_API_GATEWAY}/level/userManager/profileSettings/tableHoldingsColumnsOrder`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${userEmail}`)}`,
      },
    }
  );
